import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

interface ConnectionChangeOwnerModalEvent {
  optionSelected: ConnectionChangeOwnerModalAction;
  connectionId?: string;
  eventAction?: "click" | "view";
}

export type ConnectionChangeOwnerModalAction =
  | "confirm"
  | "cancel"
  | "success"
  | "error";

export function useEmitConnectionChangeOwnerModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({
      optionSelected,
      connectionId,
      eventAction,
    }: ConnectionChangeOwnerModalEvent) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.ConnectionChangeOwnerModal,
        optionSelected,
        eventAction: eventAction ?? "click",
        customTrackingFields: {
          connection_id: connectionId,
        },
      });
    },
    [accountId],
  );

  return { emit };
}
